import { createSelector, Selector } from 'reselect';
import { getNavigationState, State } from '../../../../reducers';

export const selectCurrentlyDisplayedCasePropertiesNames: Selector<State, string[]> =
  createSelector(
    getNavigationState,
    (navigationState) => navigationState.currentlyDisplayedCasePropertiesNames
  );
